<template>
  <!--html do computador-->
  <div class="hidden-sm hidden-xs">
    <!--html header-->
    <header>
      <div class="header-area header-transparent" style="background-color: #414145;">
        <div class="main-header header-sticky">
          <div class="container-fluid">
            <div class="menu-wrapper d-flex align-items-center justify-content-between">
              <div class="left-content d-flex align-items-center">
                <div class="logo">
                  <router-link to="/"><img src="/images/logo/logo.png" style="width: 150px;" alt=""></router-link>
                </div>
                <!-- Main-menu -->
                <div class="main-menu d-none d-lg-block">
                  <nav>
                    <ul id="navigation">
                      <li><router-link to="/">Home</router-link></li>
                      <li><router-link to="/sobre">Quem Somos</router-link></li>
                      <li><router-link to="/#">Produtos</router-link>
                        <ul class="submenu">
                          
                            <li v-for="menu in listaProdutos" :key="menu.itiId"><router-link :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome + menu.itiReferencia)">{{ menu.itiNome }} {{ menu.itiReferencia }}</router-link></li>
                          
                        </ul>
                      </li>
                      <li><router-link to="/blog">Notícias</router-link></li>
                    </ul>
                  </nav>
                </div>
              </div>
              <!-- Button -->
              <div class="buttons">
                <ul>
                  <li class="button-header">
                    <router-link to="/contato" class="white-btn header-btn2">Contato</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Mobile Menu -->
            <div class="col-12">
              <div class="mobile_menu d-block d-lg-none"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>

  <!--html do celular-->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3; background-color: #414145;">
    <div class="row celular-alinhado">
      <div class="col-3">
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item>
              <router-link to="/">
                <v-list-item-title class="link-menu-avance">Home</v-list-item-title>
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link to="/sobre">
                <v-list-item-title class="link-menu-avance">Quem Somos</v-list-item-title>
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link to="/blog">
                <v-list-item-title class="link-menu-avance">Notícias</v-list-item-title>
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link to="/contato">
                <v-list-item-title class="link-menu-avance">Contato</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img src="/images/logo/logo.png" alt=""></router-link>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageHeader',
  components: {

  },
  data: () => ({
    topoMenu: [],
    showModernizacaoMenu: false,
    listaProdutos: [],
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
    //texto e logo avance 
    axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.topoMenu = response.data;
        //console.log('topo menu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });
    // produtos  
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('lista de produtos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style scoped>
.menuTamanho {
  size: 16px;
  text-align: left;
  line-height: 1.5;
}

.celular-topo {
  margin-top: 20px;
}

.celular-alinhado {
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
  align-content: center;
  
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.link-menu-avance {
  color: #414145;
  text-decoration: none;
  transition: color 0.3s ease;
}

.link-menu-avance:hover {
  color: #D2A41C;
}
</style>
